"use strict";
angular.module('informationService', []).service("InformationService", [  function () {
    var service = {

        getProducts: function() {
            return [
                {abbreviation: null, name: "All Products"},
                {abbreviation: 1, name: "Aid"},
                {abbreviation: 2, name: "Tuition Plus"},
                {abbreviation: 3, name: "Pay"}
            ];
        },

        getStates: function () {
            //authServiceFactory.check();
            return [{"abbreviation":"AK","name":"Alaska","countries":"United States"},
                    {"abbreviation":"AL","name":"Alabama","countries":"United States"},
                    {"abbreviation":"AR","name":"Arkansas","countries":"United States"},
                    {"abbreviation":"AZ","name":"Arizona","countries":"United States"},
                    {"abbreviation":"CA","name":"California","countries":"United States"},
                    {"abbreviation":"CO","name":"Colorado","countries":"United States"},
                    {"abbreviation":"CT","name":"Connecticut","countries":"United States"},
                    {"abbreviation":"DC","name":"District of Columbia","countries":"United States"},
                    {"abbreviation":"DE","name":"Delaware","countries":"United States"},
                    {"abbreviation":"FL","name":"Florida","countries":"United States"},
                    {"abbreviation":"GA","name":"Georgia","countries":"United States"},
                    {"abbreviation":"HI","name":"Hawaii","countries":"United States"},
                    {"abbreviation":"IA","name":"Iowa","countries":"United States"},
                    {"abbreviation":"ID","name":"Idaho","countries":"United States"},
                    {"abbreviation":"IL","name":"Illinois","countries":"United States"},
                    {"abbreviation":"IN","name":"Indiana","countries":"United States"},
                    {"abbreviation":"KS","name":"Kansas","countries":"United States"},
                    {"abbreviation":"KY","name":"Kentucky","countries":"United States"},
                    {"abbreviation":"LA","name":"Louisiana","countries":"United States"},
                    {"abbreviation":"MA","name":"Massachusetts","countries":"United States"},
                    {"abbreviation":"MD","name":"Maryland","countries":"United States"},
                    {"abbreviation":"ME","name":"Maine","countries":"United States"},
                    {"abbreviation":"MI","name":"Michigan","countries":"United States"},
                    {"abbreviation":"MN","name":"Minnesota","countries":"United States"},
                    {"abbreviation":"MO","name":"Missouri","countries":"United States"},
                    {"abbreviation":"MS","name":"Mississippi","countries":"United States"},
                    {"abbreviation":"MT","name":"Montana","countries":"United States"},
                    {"abbreviation":"NC","name":"North Carolina","countries":"United States"},
                    {"abbreviation":"ND","name":"North Dakota","countries":"United States"},
                    {"abbreviation":"NE","name":"Nebraska","countries":"United States"},
                    {"abbreviation":"NH","name":"New Hampshire","countries":"United States"},
                    {"abbreviation":"NJ","name":"New Jersey","countries":"United States"},
                    {"abbreviation":"NM","name":"New Mexico","countries":"United States"},
                    {"abbreviation":"NV","name":"Nevada","countries":"United States"},
                    {"abbreviation":"NY","name":"New York","countries":"United States"},
                    {"abbreviation":"OH","name":"Ohio","countries":"United States"},
                    {"abbreviation":"OK","name":"Oklahoma","countries":"United States"},
                    {"abbreviation":"OR","name":"Oregon","countries":"United States"},
                    {"abbreviation":"PA","name":"Pennsylvania","countries":"United States"},
                    {"abbreviation":"RI","name":"Rhode Island","countries":"United States"},
                    {"abbreviation":"SC","name":"South Carolina","countries":"United States"},
                    {"abbreviation":"SD","name":"South Dakota","countries":"United States"},
                    {"abbreviation":"TN","name":"Tennessee","countries":"United States"},
                    {"abbreviation":"TX","name":"Texas","countries":"United States"},
                    {"abbreviation":"UT","name":"Utah","countries":"United States"},
                    {"abbreviation":"VA","name":"Virginia","countries":"United States"},
                    {"abbreviation":"VT","name":"Vermont","countries":"United States"},
                    {"abbreviation":"WA","name":"Washington","countries":"United States"},
                    {"abbreviation":"WI","name":"Wisconsin","countries":"United States"},
                    {"abbreviation":"WV","name":"West Virginia","countries":"United States"},
                    {"abbreviation":"WY","name":"Wyoming","countries":"United States"}
                    ];
        },
        getProvinces: function () {
            //authServiceFactory.check();
            return [{"abbreviation":"AB","name":"Alberta","countries":"Canada"},
                    {"abbreviation":"BC","name":"British Columbia","countries":"Canada"},
                    {"abbreviation":"MB","name":"Manitoba","countries":"Canada"},
                    {"abbreviation":"NB","name":"Nouveau-Brunswick","countries":"Canada"},
                    {"abbreviation":"NL","name":"Newfoundland","countries":"Canada"},
                    {"abbreviation":"NS","name":"Nova Scotia","countries":"Canada"},
                    {"abbreviation":"NT","name":"Northwest Territories","countries":"Canada"},
                    {"abbreviation":"NU","name":"Nunavut","countries":"Canada"},
                    {"abbreviation":"ON","name":"Ontario","countries":"Canada"},
                    {"abbreviation":"PE","name":"Prince Edward Island","countries":"Canada"},
                    {"abbreviation":"QC","name":"Quebec","countries":"Canada"},
                    {"abbreviation":"SK","name":"Saskatchewan","countries":"Canada"},
                    {"abbreviation":"YT","name":"Yukon","countries":"Canada"}];
        },

        getCountries: function() {
            return [{abbreviation:"USA",name:"United States"},
                    {abbreviation:"CAN",name:"Canada"},
                    {abbreviation:"ARG",name:"Argentina"},
                    {abbreviation:"AUS",name:"Australia"},
                    {abbreviation:"AUT",name:"Austria"},
                    {abbreviation:"BHR",name:"Bahrain"},
                    {abbreviation:"BEL",name:"Belgium"},
                    {abbreviation:"BMU",name:"Bermuda"},
                    {abbreviation:"BOL",name:"Bolivia"},
                    {abbreviation:"BRA",name:"Brazil"},
                    {abbreviation:"COL",name:"Colombia"},
                    {abbreviation:"CZE",name:"Czech Republic"},
                    {abbreviation:"DOM",name:"Dominican Republic"},
                    {abbreviation:"ECU",name:"Ecuador"},
                    {abbreviation:"EGY",name:"Egypt"},
                    {abbreviation:"SLV",name:"El Salvador"},
                    {abbreviation:"FIN",name:"Finland"},
                    {abbreviation:"FRA",name:"France"},
                    {abbreviation:"GEO",name:"Georgia"},
                    {abbreviation:"GHA",name:"Ghana"},
                    {abbreviation:"HUN",name:"Hungary"},
                    {abbreviation:"IND",name:"India"},
                    {abbreviation:"ISR",name:"Israel"},
                    {abbreviation:"ITA",name:"Italy"},
                    {abbreviation:"JAM",name:"Jamaica"},
                    {abbreviation:"JOR",name:"Jordan"},
                    {abbreviation:"KEN",name:"Kenya"},
                    {abbreviation:"KOR",name:"Korea, Republic of"},
                    {abbreviation:"LAO",name:"Lao People’s Democratic Republic"},
                    {abbreviation:"LBN",name:"Lebanon"},
                    {abbreviation:"LUX",name:"Luxembourg"},
                    {abbreviation:"MEX",name:"Mexico"},
                    {abbreviation:"NIC",name:"Nicaragua"},
                    {abbreviation:"NOR",name:"Norway"},
                    {abbreviation:"PAK",name:"Pakistan"},
                    {abbreviation:"PAN",name:"Panama"},
                    {abbreviation:"PER",name:"Peru"},
                    {abbreviation:"POL",name:"Poland"},
                    {abbreviation:"QAT",name:"Qatar"},
                    {abbreviation:"SAU",name:"Saudi Arabia"},
                    {abbreviation:"SEN",name:"Senegal"},
                    {abbreviation:"SWZ",name:"Swaziland"},
                    {abbreviation:"THA",name:"Thailand"},
                    {abbreviation:"TTO",name:"Trinidad and Tobago"},
                    {abbreviation:"TUR",name:"Turkey"},];
        },

        getPhilosophies: function() { // TODO
            return [{abbreviation:"CARD", name:"Carden"},
                    {abbreviation:"CHAR", name:"Charter"},
                    {abbreviation:"CLAS", name:"Classical Christian"},
                    {abbreviation:"COMM", name:"Community Jewish"},
                    {abbreviation:"CONS", name:"Conservative Jewish"},
                    {abbreviation:"DIOC", name:"Diocesan"},
                    {abbreviation:"INDE", name:"Independent"},
                    {abbreviation:"MONT", name:"Montessori"},
                    {abbreviation:"ORTH", name:"Orthodox Jewish"},
                    {abbreviation:"PUBL", name:"Public"},
                    {abbreviation:"SOLO", name:"Solomon Schecter"},
                    {abbreviation:"WALD", name:"Waldorf"},
                    {abbreviation:"WESL", name:"Weslyan"}];
        },

        getSchoolPrefixes: function()
        {
            return ["Mr.", "Mrs.", "Ms.", "Miss", "Abbot", "Bishop", "Br.", "Chapln.", "Col.", "Dr.", "Prof.", "Rabbi", "Rev.", "Rt. Rev.", "Sr."];
        },
        getReligions: function(){
            return [{abbreviation:"ADVE", name:"7th Day Adventist"},
                    {abbreviation:"AMIS", name:"Amish"},
                    {abbreviation:"ANGL", name:"Anglican"},
                    {abbreviation:"ARM", name:"Armenian"},
                    {abbreviation:"BAPT", name:"Baptist"},
                    {abbreviation:"BUDD", name:"Buddhist"},
                    {abbreviation:"CALV", name:"Calvinist"},
                    {abbreviation:"CATH", name:"Catholic"},
                    {abbreviation:"Catholic", name:"Catholic"},
                    {abbreviation:"CHRI", name:"Christian"},
                    {abbreviation:"Christian", name:"Christian"},
                    {abbreviation:"Christian Sc", name:"Christian Science"},
                    {abbreviation:"CEng", name:"Church of England"},
                    {abbreviation:"DELP", name:"Delphi"},
                    {abbreviation:"EPIS", name:"Episcopal"},
                    {abbreviation:"FRIE", name:"Friends"},
                    {abbreviation:"GREE", name:"Greek"},
                    {abbreviation:"ISLA", name:"Islamic"},
                    {abbreviation:"JEWI", name:"Jewish"},
                    {abbreviation:"LUTH", name:"Lutheran"},
                    {abbreviation:"MENN", name:"Mennonite"},
                    {abbreviation:"METH", name:"Methodist"},
                    {abbreviation:"MONT", name:"Montessori"},
                    {abbreviation:"MORA", name:"Moravian"},
                    {abbreviation:"MUSL", name:"Muslim"},
                    {abbreviation:"NAZA", name:"Nazarene"},
                    {abbreviation:"NOND", name:"Non-Denominational"},
                    {abbreviation:"NONR", name:"Non-Religious"},
                    {abbreviation:"NONE", name:"None"},
                    {abbreviation:"PENT", name:"Pentecostal"},
                    {abbreviation:"PRES", name:"Presbyterian"},
                    {abbreviation:"PROT", name:"Protestant"},
                    {abbreviation:"PUBL", name:"Public"},
                    {abbreviation:"QUAK", name:"Quaker"},
                    {abbreviation:"SIKH", name:"Sikh"},
                    {abbreviation:"UNIA", name:"Unitarian"},
                    {abbreviation:"UNIT", name:"Uniting Church"},
                    {abbreviation:"WESL", name:"Wesleyan"}];
        },
        getGrades: function(){
            return [{abbreviation:"PS", name:"Pre-School"},
                    {abbreviation:"PK", name:"Pre-Kindergarden"},
                    {abbreviation:"KK", name:"Kindergarden"},
                    {abbreviation:"1", name:"1"},
                    {abbreviation:"2", name:"2"},
                    {abbreviation:"3", name:"3"},
                    {abbreviation:"4", name:"4"},
                    {abbreviation:"5", name:"5"},
                    {abbreviation:"6", name:"6"},
                    {abbreviation:"7", name:"7"},
                    {abbreviation:"8", name:"8"},
                    {abbreviation:"9", name:"9"},
                    {abbreviation:"10", name:"10"},
                    {abbreviation:"11", name:"11"},
                    {abbreviation:"12", name:"12"},
                    {abbreviation:"13", name:"13+"}];

        },
        getContactTypes: function(){
            return [{abbreviation:'ADM', name:'Director of Admissions'},
                    {abbreviation:'ADM2', name:'Subordinate Admission personnel'},
                    {abbreviation:'ADML', name:'Admission Director, Lower School'},
                    {abbreviation:'ADMM', name:'Admission Director, Middle School'},
                    {abbreviation:'ADMU', name:'Director of Admission, Upper Division'},
                    {abbreviation:'AGENT', name:'Insurance Agent'},
                    {abbreviation:'ALUM', name:'Director of Alumni Affairs'},
                    {abbreviation:'ANN', name:'Director of Annual Funds'},
                    {abbreviation:'ATH', name:'Director of Athletics'},
                    {abbreviation:'ATT', name:'Attorney'},
                    {abbreviation:'AUX', name:'Director of Auxiliary Programs'},
                    {abbreviation:'BANQ', name:'Banquet Director'},
                    {abbreviation:'BOA1', name:'Board Chairman'},
                    {abbreviation:'BOA2', name:'Board Treasurer'},
                    {abbreviation:'BOAR', name:'Board Memeber/Trustee'},
                    {abbreviation:'BUS', name:'Business Manager'},
                    {abbreviation:'BUS2', name:'Assistant Business Manager'},
                    {abbreviation:'COLL', name:'College Counselor'},
                    {abbreviation:'COM', name:'Director of Public Relations'},
                    {abbreviation:'DEA1', name:'Dean of Academics'},
                    {abbreviation:'DEA2', name:'Dean of Discipline'},
                    {abbreviation:'DEA3', name:'Dean of Students'},
                    {abbreviation:'DEA4', name:'Dean of Faculty'},
                    {abbreviation:'Deceased', name:'Deceased'},
                    {abbreviation:'DEV', name:'Director of Institutional Advancement'},
                    {abbreviation:'DEV2', name:'Assistant Director of Institutional Advancement'},
                    {abbreviation:'DIV', name:'Director of Diversity'},
                    {abbreviation:'DIVB', name:'Director, Boarding Division'},
                    {abbreviation:'DIVI', name:'Director of International Students'},
                    {abbreviation:'DIVL', name:'Director of Admission, Lower Division'},
                    {abbreviation:'DIVM', name:'Director of Admission, Middle Division'},
                    {abbreviation:'DIVP', name:'Director, Preschool'},
                    {abbreviation:'DIVU', name:'Director, Upper'},
                    {abbreviation:'DIVX', name:'Director, Misc. Division'},
                    {abbreviation:'FACU', name:'Teacher/Faculty Member'},
                    {abbreviation:'FINA', name:'Director of Financial Aid'},
                    {abbreviation:'FOOD', name:'Food Service Personnel'},
                    {abbreviation:'GUI', name:'Guidance Counselor'},
                    {abbreviation:'HEA2', name:'Associate Head of School'},
                    {abbreviation:'HEA3', name:'President/Head Emeritus'},
                    {abbreviation:'HEAD', name:'Head of School'},
                    {abbreviation:'ISM - Adj Consultant', name:'ISM - Adj Consultant'},
                    {abbreviation:'ISM - Consultant', name:'ISM - Consultant'},
                    {abbreviation:'ISM - Staff', name:'ISM - Staff'},
                    {abbreviation:'ISM - Workshop Leader', name:'ISM - Workshop Leader'},
                    {abbreviation:'LIB', name:'Librarian'},
                    {abbreviation:'MIN', name:'Minister'},
                    {abbreviation:'MKT', name:'Director of Marketing'},
                    {abbreviation:'NURS', name:'Nurse/Health Official'},
                    {abbreviation:'PAR', name:'Director of Parent Relations'},
                    {abbreviation:'PERS', name:'Director of Human Resouces'},
                    {abbreviation:'PLAN', name:'Director of Facilities'},
                    {abbreviation:'Producer', name:'Producer'},
                    {abbreviation:'Producer/Agent', name:'Producer/Agent'},
                    {abbreviation:'Producer/CM', name:'Producer/CM'},
                    {abbreviation:'SCH', name:'Scheduler/Registrar'},
                    {abbreviation:'SEC', name:'Secretary'},
                    {abbreviation:'Student', name:'Student'},
                    {abbreviation:'SUM', name:'Director of Summer Programs'},
                    {abbreviation:'TECH', name:'Director of Technology'},
                    {abbreviation:'TRAN', name:'Director of Transportation'},
                    {abbreviation:'ADMP', name:'Admission Director, Preschool'}];
        }
    };

    return service;
}]);